import {
  GET_TRACKER_INFO,
  GET_TRACKER_INFO_ERROR
} from "../constants/TrackerConstants";

const INITIAL_STATE = {
  trackerInfo: null,
  loading: true
};
const trackerReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_TRACKER_INFO:
      return {
        ...state,
        trackerInfo: action.payload,
        loading: false
      };
    case GET_TRACKER_INFO_ERROR:
      return Object.assign({}, state, { error: action.payload });
    default:
      return state;
  }
};

export default trackerReducer;
